import { getBusinessEntityTypeOptions } from './getBusinessEntityTypeOptions';
import type { SelectDropdownOption } from '../../../library/editors/elements/select-dropdown-option';

export const businessEntityTypeOptions: SelectDropdownOption[] = getBusinessEntityTypeOptions();
